const initialState = {
  orgStorage: {} as Record<
    string,
    { storeUsed: number; storeLimit: number } | null
  >,
};

const myPlanReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_ORG_STORAGE_DATA":
      return {
        ...state,
        orgStorage: {
          ...state.orgStorage,
          [action.payload.key]: action.payload.storage,
        },
      };
    case "SET_ORG_STORAGE_STATE":
      return initialState; // clears everything
    default:
      return state;
  }
};

export default myPlanReducer;
